import { useState } from 'react';

import { Button, Collapse, ListItem, Tooltip } from '@material-ui/core';
import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons';
import clsx from 'clsx';
import { NavLink as RouterLink } from 'react-router-dom';

import { useStyles } from './index.style';
import { NavItemProps } from './types';

const NavItem = ({
  children,
  className,
  collapsed,
  depth,
  href,
  icon: Icon,
  info: Info,
  open: openProp,
  title,
  isActive,
  ...rest
}: NavItemProps) => {
  const classes = useStyles();
  const [open, setOpen] = useState(Boolean(openProp));

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = { paddingLeft };

  if (children) {
    const button = (
      <Button
        className={clsx(classes.button, {
          [classes.buttonCollapsed]: collapsed,
        })}
        onClick={handleToggle}
        style={collapsed ? undefined : style}
      >
        {Icon && <Icon className={classes.icon} size="20" />}
        {!collapsed && <span className={classes.title}>{title}</span>}
        {!collapsed && (open ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
      </Button>
    );

    return (
      <ListItem
        className={clsx(classes.item, className)}
        disableGutters
        key={title}
        {...rest}
      >
        {collapsed ? (
          <Tooltip title={title} placement="right">
            {button}
          </Tooltip>
        ) : (
          button
        )}
        {!collapsed && <Collapse in={open}>{children}</Collapse>}
      </ListItem>
    );
  }

  if (!href) {
    return (
      <ListItem
        className={clsx(classes.itemLeaf, className)}
        disableGutters
        key={title}
        {...rest}
      />
    );
  }

  const leafButton = (
    <Button
      activeClassName={classes.active}
      className={clsx(classes.buttonLeaf, `depth-${depth}`, {
        [classes.active]: isActive,
        [classes.buttonCollapsed]: collapsed,
      })}
      component={RouterLink}
      style={collapsed ? undefined : style}
      exact
      to={href}
    >
      {Icon && <Icon className={classes.icon} size="20" />}
      {!collapsed && <span className={classes.title}>{title}</span>}
      {!collapsed && Info && <Info />}
    </Button>
  );

  return (
    <ListItem
      className={clsx(classes.itemLeaf, className)}
      disableGutters
      key={title}
      {...rest}
    >
      {collapsed ? (
        <Tooltip title={title} placement="right">
          {leafButton}
        </Tooltip>
      ) : (
        leafButton
      )}
    </ListItem>
  );
};

NavItem.defaultProps = {
  open: false,
};

export default NavItem;
